import { IBAN_NUMBER } from "pages/forms/customForms/_customFields/BeneficiaryField/Constants";

const IBAN_REQUIRED_BY_COUNTRY_MESSAGE =
    "forms.transfer.foreign.field.account.iban.requiredByCountry.message";
const ACCOUNT_NUMBER_REQUIRED_BY_COUNTRY_MESSAGE =
    "forms.transfer.foreign.field.account.accountNumber.requiredByCountry.message";
export const PRELOADED_BENEFICIARY_INVALID_FOR_COUNTRY_MESSAGE =
    "forms.transfer.foreign.field.account.preloadedBeneficiary.invalidForCountry.message";

export const FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON = {
    IBAN_REQUIRED: "IBAN_REQUIRED",
    ACCOUNT_REQUIRED: "ACCOUNT_REQUIRED",
};

const REASON_TO_MESSAGE_KEY = {
    [FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.IBAN_REQUIRED]: IBAN_REQUIRED_BY_COUNTRY_MESSAGE,
    [FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.ACCOUNT_REQUIRED]: ACCOUNT_NUMBER_REQUIRED_BY_COUNTRY_MESSAGE,
};

/**
 * Typed mismatch for accountType vs bankCountry IBAN list (no i18n).
 */
export const getForeignAccountCountryMismatchReason = (beneficiary, configUtils) => {
    if (!beneficiary || !configUtils) {
        return null;
    }

    const enabled = configUtils.getBoolean("transfers.foreign.iban.countryValidation.enabled", false);
    if (!enabled) {
        return null;
    }

    const bankCountry = beneficiary.bankCountry;
    if (!bankCountry) {
        return null;
    }

    const countryCode = String(bankCountry).toUpperCase();
    const orAccountCountries = configUtils.getArray("transfers.foreign.iban.orAccount.countries") || [];
    // Dual list: country accepts both IBAN and account number
    if (orAccountCountries.some((code) => String(code).toUpperCase() === countryCode)) {
        return null;
    }

    const requiredCountries = configUtils.getArray("transfers.foreign.iban.required.countries") || [];
    const ibanRequired = requiredCountries.some(
        (code) => String(code).toUpperCase() === countryCode,
    );
    const { accountType } = beneficiary;

    if (ibanRequired && accountType !== IBAN_NUMBER) {
        return FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.IBAN_REQUIRED;
    }

    if (!ibanRequired && accountType === IBAN_NUMBER) {
        return FOREIGN_ACCOUNT_COUNTRY_MISMATCH_REASON.ACCOUNT_REQUIRED;
    }

    return null;
};

export const getForeignAccountCountryMismatchMessage = (beneficiary, i18n, configUtils) => {
    if (!i18n) {
        return null;
    }

    const reason = getForeignAccountCountryMismatchReason(beneficiary, configUtils);
    if (!reason) {
        return null;
    }

    return i18n.get(REASON_TO_MESSAGE_KEY[reason]);
};

export const isPreloadedBeneficiary = (beneficiary) =>
    Boolean(beneficiary?.beneficiaryId || beneficiary?.idBeneficiary);
